import React from 'react'
import {List} from '@mui/material'
import {css, useTheme} from '@emotion/react'

import {useDeveloperMode} from '../../../contexts/developerMode'
import {Link} from '../../../app/i18n/routing'


function ToolList({tools}) {
  const theme = useTheme()
  const styles = {
    root: css`
      b {
        color: ${theme.palette.secondary.main};
      }
    `,

    item: css`
      position: relative;

      padding: 16px;
      color: inherit;
      text-decoration: none;
      user-select: none;

      display: flex;
      align-items: center;

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    `,

    privateTag: css`
      margin-left: 4px;
      color: ${theme.palette.secondary.dark};
      font-size: 12px;
    `
  }

  const developMode = useDeveloperMode()

  return (
    <List css={styles.root}>
      {tools.map(tool => (
        <li key={tool.label}>
          <Link css={styles.item} href={tool.url}>
            <span dangerouslySetInnerHTML={{__html: tool.label}}/>
            {developMode && tool.isPrivate ? (
              <span css={styles.privateTag}>[P]</span>
            ) : null}
          </Link>
        </li>
      ))}
    </List>
  )
}

export default React.memo(ToolList)